import React from "react";
import { Col, Button } from "reactstrap";
import "../styles/car-card.css";

const TrendingBrandCard = ({ item, onClick }) => {
  const carItemStyle = {
    cursor: "pointer",
    // Optionally, add some additional styles for hover effect
    boxShadow: "0 0 4px rgba(0, 0, 0, 0.2)",
    // transform: "translateY(-2px)",
  };
  return (
    <Col lg="2" md="2" sm="6" xs={"4"} className="mb-5">
      <div style={carItemStyle} onClick={onClick}>
        <div className="car__item-img ">
          <img src={item.imageUrl} alt="" className="w-100" />
        </div>
      </div>
    </Col>
  );
};

export default TrendingBrandCard;
